import { convertToExportedView } from '@estee/elc-service';
import { serviceNames } from '~setup/OffersService';
import { ISamplesSetComponentProps } from './SamplesSetComponent';

export type INTERFACE = ISamplesSetComponentProps;

// @ts-ignore
export default convertToExportedView<ISamplesSetComponentProps>(
    // @ts-ignore
    () => import('./SamplesSetComponent'),
    'samplesComponent',
    serviceNames.offerCodeModuleViewController
);